<app-modal
    [size]="platformService.isMobile ? 'large' : 'medium'"
    [open]="open"
    (dismiss)="onCancel()"
>
    <ion-header>
        <div>
            <ion-text>
                <h2>Have a question or need help?</h2>
            </ion-text>
            <ion-text>
                <p>Please fill out the form below and we'll get back to you as soon as possible.</p>
            </ion-text>
        </div>
    </ion-header>
    <ion-content class="ion-no-padding {{selector}}">
        <form [formGroup]="supportForm" (ngSubmit)="onSubmit()">
              <div>
                <ion-text>
                    <p class="ion-no-padding ion-no-margin small">
                        Subject <sup>*</sup>
                    </p>
                </ion-text>
                <ion-input autocomplete="off" type="text" formControlName="subject" required></ion-input>
              </div>
              <div>
                <ion-text>
                    <p class="ion-no-padding ion-no-margin small">
                        Message <sup>*</sup>
                    </p>
                </ion-text>
                <ion-textarea formControlName="message" name="message" required rows="6" ></ion-textarea>
              </div>
        </form>
    </ion-content>
    <ion-footer>
        <ion-button mode="md" fill="clear" color="danger" (click)="onCancel()">Cancel</ion-button>
        <ion-button mode="md" color="secondary" (click)="onSubmit()">Send</ion-button>
    </ion-footer>
</app-modal>